import React, { useState } from "react";
import styled, { createGlobalStyle, css } from "styled-components";
import { graphql } from "gatsby";

import Layout from "./main-layout";
import FullHeight from "../components/full-height-hero-section";
import AppWindow from "../components/window-styled-container";
import PartaiSmallCircle from "../components/partai-logo";
// import ListWindow from "./list-window";
import GradientTitle from "../components/titles/gradient-with-pill";
import GoIcon from "../assets/svg/chevron-circle-right.svg";
import Modal from "../components/modal";
import LinkButton from "../components/link-button";
import Card from "../components/card";

const GlobalStyle = createGlobalStyle`
    body {
        background-color: var(--kpum-cream);
    }
`;

const TopSection = styled(FullHeight)`
    display: flex;
    flex-direction: row;
    align-items: center;

    @media only screen and (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;

        min-height: 0;
    }
`;

const PartaiLogo = styled(PartaiSmallCircle)`
    width: 15rem;
    height: 15rem;
    margin: 0 auto;
`;

const PartaiName = styled.h1`
    font-family: var(--qanelas-main);
    font-weight: bold;
    font-size: 3em;

    width: fit-content;
    margin: 0 auto;
    margin-top: 1em;
`;

const PartaiBrandingContainer = styled.div`
    flex-grow: 1;
    margin: 3rem 0;
`;


const Window = styled(AppWindow)`
    padding: 1em;
    margin: 0 auto;
    margin-bottom: 2.5rem; /* ? */

    /* width: 100%; */
    max-width: 650px;

    color: var(--kpum-black);
`;

const ListItemWrapper = styled.div`
    max-width: 60ch;
    margin: 0 auto;
`;

const Title = styled.h1`
    font-family: var(--qanelas-main);
    font-size: 2.5em;
    font-weight: 400;
    margin: 0;
`;

const ItemGroup = styled.ol`
    margin: 0;
    padding: 0;
    counter-reset: nomor;
    max-height: 400px;
    overflow-x: hidden; /* Hide horizontal scrollbar */
    overflow-y: auto; /* Add vertical scrollbar */
`;

const markerSize = 2;
const lineHeight = 1.25;

/* Here comes the magic (this is some heavy math shit right here) */
const outPadding = `calc(calc(${markerSize + "em"} - ${lineHeight + "em"}) / 2)`;

const Item = styled.li`
    list-style: none;
    counter-increment: nomor;

    display: flex;
    align-items: flex-start;

    line-height: ${lineHeight};

    margin-top: calc(${outPadding} + 1em);

    font-weight: 500;

    &::before {
        display: flex;
        align-items: center;
        justify-content: center;

        content: counter(nomor);
        font-weight: bold;

        width: ${markerSize + "em"};
        height: ${markerSize + "em"};
        border-radius: 50%;

        margin-top: calc(-1 * ${outPadding});
        margin-right: 0.5em;

        flex-shrink: 0;

        color: white;
        background-color: var(--kpum-black);

        ${props => props.markerCSS}
    }

    position: relative;

    /* Divider lines (FIXME) */
    &:not(:last-child)::after {
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        background-color: currentColor;
        opacity: 0.2;
        position: absolute;
        left: 0;
        bottom: -0.5em; /* FIXME */
    }
`;

const ListWindow = ({ style, titleStyle, markerCSS, className, title, contents }) => (
    <Window style={style} className={className}>
        <ListItemWrapper>
            <Title style={titleStyle}>{title}</Title>
            <ItemGroup>
                {contents.map((item) => (<Item markerCSS={markerCSS}>{item}</Item>))}
            </ItemGroup>
        </ListItemWrapper>
    </Window>
);

const Proker = styled(ListWindow)`
    background: linear-gradient(to top, var(--kpum-orange) -50%, var(--kpum-lightorange) 150%);
    color: white;
    margin: 2rem 2rem;

    flex-grow: 1;
    width: none;
`;

const dashedLineSectionDivider = color => css`
    &::before {
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        background: repeating-linear-gradient(
            to right,
            ${color},
            ${color} 25px,
            transparent 25px,
            transparent 35px
        );
    }
`;

const Visi = ({ children }) => {
    const VisiSection = styled.section`
        background-color: var(--kpum-lightorange);
        padding: 0 2rem;

        position: relative;

        ${dashedLineSectionDivider(`rgb(255 255 255 / 0.5)`)}

        &::after {
            content: "";
            display: block;
            position: absolute;
            width: 100%;
            background-color: inherit;
            left: 0;

            height: 12rem;
            top: 100%;
            z-index: -1;
            border-bottom-right-radius: 100% 5rem;
        }
    `;

    const VisiContainer = styled.div`
        max-width: 800px;
        width: fit-content;
        margin: 5rem auto;
        /* color: var(--kpum-black); */
    `;

    const Title = styled.h1`
        font-family: var(--qanelas-main);
        font-size: 1.5em;
        font-weight: normal;
    `;

    const Content = styled.p`
        display: block;
        font-family: var(--sekogure-main);
        font-size: 2em;
        /* font-weight: bold;
        font-style: italic; */
        text-decoration: underline;
        margin: 0;
        text-shadow: 0.05em 0.05em 0 var(--kpum-cream); /* ? */
    `;

    return (
        <VisiSection>
            <VisiContainer>
                <Title>Visi:</Title>
                <Content>{children}</Content>
            </VisiContainer>
        </VisiSection>
    )
};

const VideografisSection = styled.section`
    padding: 5rem 2rem;
`;

const VideografisWindow = styled(AppWindow)`
    width: fit-content;
    margin: 0 auto;
    overflow: hidden;

    iframe {
        display: block;
        width: 60rem;
        height: 40rem;

        @media only screen and (max-width: 640px) {
            height: 25rem;
        }

        @media only screen and (max-width: 480px) {
            height: 15rem;
        }

        max-width: 100%;

        /* Reset appearance */
        border: none;
        margin: 0;
        padding: 0;
    }
`;


const DapilGrid = styled.ul`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    /* Reset all child li elements to block */
    li {
        display: block;
    }

    max-width: 80rem;
    margin: 0 auto;
    padding: 0;

    & > li {
        flex-grow: 1;
        max-width: 500px;
        flex-basis: 400px;

        display: flex;
        flex-direction: column;
    }
`;

const DapilWindow = styled(AppWindow)`
    padding: 2rem;
    margin: 1rem;

    height: 100%;

    background-color: rgb(255 255 255 / 0.5);
`;

const DapilWrapper = styled.div`
    /* Fix for collapsing margins */
    display: flex;
    flex-direction: column;

    height: 100%;

    & > ul {
        /* Some resets */
        margin: 0;
        padding: 1em;

        height: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;

const DapilTitle = styled.h2`
    margin: 0 auto 0.8em auto;
    /* margin-top: 0; */
    text-align: center;

    font-family: var(--qanelas-main);
    font-weight: bold;
    font-size: 1.8em;
`;

const Calon = styled.a`
    /* padding: 1em 0.5em; */
    cursor: pointer;
    margin-left: 0.5em;
    margin-bottom: 1em;

    border-radius: 0.5rem;
    background-color: rgb(0 0 0 / 0.0);

    display: flex;
    align-items: center;
    flex-grow: 2;
    justify-content: space-between;

    color: black;
    text-decoration: none;
    font-size: 0.9em;

    h3 {
        display: table;
        font-size: 1em;
        background-color: rgb(255 255 255 / 1.0);
        box-shadow: 0 1px 3px rgb(0 0 0 / 0.2);
        border-radius: 2em;
        padding:5px;
        margin: 0;
    }

    p {
        margin: 0;
        margin-top: 0.25em;
    }

    & > svg {
        align-self: flex-end;
        width: 1.25em;
        height: auto;
        margin: 0;
        margin-left: 1em;
    }

    transition: background-color 0.2s;

    /* &:hover {
        background-color: rgb(0 0 0 / 0.15);
        h3 {
            text-decoration: underline;
        }
    } */
`;

const ModalContent = styled.div`
    h1 {
        font-size: 1.75em;
        font-family: var(--qanelas-main);
        font-weight: 700;

        width: fit-content;
        margin: 0 auto 0.25em auto;
    }

    p {
        font-family: var(--qanelas-main);
        font-weight: 300;
        font-size: 1.25em;

        width: fit-content;
        margin: 0 auto 1em auto;
    }

    iframe {
        display: block;
        margin: 0 auto;

        height: 60vh;
        width: 60vw;

        @media only screen and (max-width: 768px) {
            width: 100%;
        }
    }
`;

const ModalCalonButton = styled(LinkButton)`
    display: block;
    width: fit-content;
    margin: 1rem auto;
`;

const ModalCalonButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

const ModalDownloadButton = styled(LinkButton)`
    display: block;
    width: fit-content;
    margin: 1rem auto;
`;


const ButtonGroup = styled.div`
    display: flex;
    width: fit-content;
    margin: 1rem auto;

    @media only screen and (max-width: 768px) {
        margin: 1rem auto;
    }
`;

const ButtonContainer = styled.a`
        margin-right: 1em;
        cursor: pointer;
`;

const createDriveDownloadUrl = id => `https://drive.google.com/u/1/uc?id=${id}&export=download`

const PartaiBranding = ({ nama, singkatan, laporanKampanyeDriveFileId}) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const [modalData, setModalData] = useState({
        iframeSrcUrl: null,
        downloadUrl: null
    });

    const createDriveDownloadUrl = id => `https://drive.google.com/u/1/uc?id=${id}&export=download`

    function showModal(e, driveFileId) {
        e.preventDefault();

        setModalData({
            iframeSrcUrl: `https://drive.google.com/file/d/${driveFileId}/preview`,
            downloadUrl: createDriveDownloadUrl(driveFileId)
        });

        setModalOpen(true);
    }

    return (
        <PartaiBrandingContainer>
            <PartaiLogo nama={singkatan} />
            <PartaiName>{nama}</PartaiName>
            <ButtonGroup>
                <ButtonContainer onClick={e => showModal(e, laporanKampanyeDriveFileId)}>
                    <LinkButton>
                        Laporan Dana Kampanye
                    </LinkButton>
                </ButtonContainer>
            </ButtonGroup>
            <Modal show={isModalOpen} handleClose={() => setModalOpen(false)}>
                <ModalContent>
                    <iframe src={modalData.iframeSrcUrl} />
                    <ModalDownloadButton external to={modalData.downloadUrl}>Unduh</ModalDownloadButton>
                </ModalContent>
            </Modal>
        </PartaiBrandingContainer>
    )
};

const Dapil = ({ namaDapil, calonArray }) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const [modalData, setModalData] = useState({
        nama: null,
        fakultas: null,
        iframeSrcUrl: null,
        infografisDriveFileId: null,
        cvDriveFileId: null,
        esaiDriveFileId: null
    });

    
    function showModal(e, calon) {
        e.preventDefault();

        setModalData({
            nama: calon.nama,
            fakultas: calon.fakultas,
            iframeSrcUrl: `https://drive.google.com/file/d/${calon.infografisDriveFileId}/preview`,
            infografisDriveFileId: calon.infografisDriveFileId,
            cvDriveFileId: calon.cvDriveFileId,
            esaiDriveFileId: calon.esaiDriveFileId
        });

        setModalOpen(true);
    }

    const CustomCard = styled(Card).attrs({ as: "li" })`
        display: flex;
        flex-direction: column;
        list-style: none;

        background-color: var(--kpum-cream);
        backdrop-filter: blur(20px);
        box-shadow: 0 2px 5px rgb(0 0 0 / 0.25);
        /* max-width: 500px; */
        width: 80%;
        margin: 0 auto;

        padding: 1.5em;

        counter-increment: dapil-count;

        transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        
        /*
        animation: move-right 0.4s;
        @keyframes move-right {
            from { 
                transform: translateX(-30%);
                opacity: 0;
                }
        } 
        */

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 6px 8px rgb(0 0 0 / 0.25);
        }

        &:not(:last-child) {
            margin-bottom: 1em;
        }
    `;

    const Number = styled.div`
        /* display: block; */
        /* width: 100px;
        height: 100px; */
        min-width: 1ch;
        text-align: right;
        /* margin-right: 0.6em; */
        
        /* background-color: greenyellow; */
        font-size: 2.5em;
        font-style: italic;
        font-weight: 600;
        line-height: 1;

        &::after {
            content: counter(dapil-count);
        }

        flex-shrink: 0; /* FIXME */
    `;

    const CustomContainer = styled.div`
        display: flex;
    `;

    const CalonContainer = ({calon}) => (
        <CustomContainer>
            <Number/>
            {/* Progressive enhancement */}
            <Calon href={calon.infografikUrl} title="Klik untuk melihat CV dan infografik" onClick={e => {
                showModal(e, calon);
            }}>
                    <div>
                        <h3>{calon.nama}</h3>
                        <p>{calon.fakultas}</p>
                    </div>
                <GoIcon />
            </Calon>
        </CustomContainer>
    );

    return (
        <DapilWindow contentContainerStyle={{ height: `100%` }}>
            <DapilWrapper>
                <DapilTitle>{namaDapil}</DapilTitle>
                <ul>
                    {calonArray.map(calon => (
                        <CustomCard>
                            <CalonContainer calon = {calon}/>
                        </CustomCard>
                    ))}
                </ul>
            </DapilWrapper>
            <Modal show={isModalOpen} handleClose={() => setModalOpen(false)}>
                <ModalContent>
                    <h1>{modalData.nama}</h1>
                    <p>{modalData.fakultas}</p>
                    <iframe src={modalData.iframeSrcUrl} />
                    <ModalCalonButtonContainer>
                        <ModalCalonButton external to={createDriveDownloadUrl(modalData.cvDriveFileId)}>CV</ModalCalonButton>
                        <ModalCalonButton external to={createDriveDownloadUrl(modalData.esaiDriveFileId)}>Esai</ModalCalonButton>
                        <ModalCalonButton external to={createDriveDownloadUrl(modalData.infografisDriveFileId)}>Infografis</ModalCalonButton>
                    </ModalCalonButtonContainer>
                </ModalContent>
            </Modal>
        </DapilWindow>
    )
};

const DapilSection = ({ dapilArray }) => (
    <section style={{ paddingBottom: `5rem` }}>
        <GradientTitle style={{ fontSize: `0.8em` }}>Daerah Pemilihan</GradientTitle>
        <DapilGrid>
            {dapilArray.map(dapil => (
                <li>
                    <Dapil namaDapil={dapil.dapil} calonArray={dapil.calon} />
                </li>
            ))}
        </DapilGrid>
    </section>
);


const ParmaPage = ({ data }) => (
    <Layout title={data.parmaJson.namaPartai}>
        <GlobalStyle />
        <TopSection>
            <PartaiBranding nama={data.parmaJson.namaPartai} singkatan={data.parmaJson.singkatanPartai}  laporanKampanyeDriveFileId={data.parmaJson.laporanKampanyeDriveFileId}/>
            <Proker title="Program Kerja" contents={data.parmaJson.proker} titleStyle={{
                fontWeight: `bold`,
                textShadow: `0 0.06em 0.2em rgb(0 0 0 / 0.5)`
            }} markerCSS={css`
                color: var(--kpum-black);
                background-color: white;
                box-shadow: 0 2px 4px rgb(0 0 0 / 0.5);
            `}/>
        </TopSection>
        {/* <Visi>{data.parmaJson.visi}</Visi>
        <section style={{ padding: `1rem` }}>
            <ListWindow title="Misi" contents={data.parmaJson.misi} />
        </section> */}
        {data.parmaJson.videografisUrl ? (
                    <VideografisSection>
                    <VideografisWindow>
                        <iframe src={data.parmaJson.videografisUrl} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"/>
                    </VideografisWindow>
                </VideografisSection>
        ) : null}
        <DapilSection dapilArray={data.parmaJson.pembagianDapil} />
    </Layout>
);

export default ParmaPage;

export const query = graphql`
    query($slug: String!) {
        parmaJson(fields: { slug: { eq: $slug } }) {
            fields {
                noUrut
            }
            namaPartai
            singkatanPartai
            proker
            visi
            misi
            videografisUrl
            laporanKampanyeDriveFileId
            pembagianDapil {
                dapil
                calon {
                    nama
                    fakultas
                    infografisDriveFileId
                    cvDriveFileId
                    esaiDriveFileId
                }
            }
        }
    }
`;